import { render, staticRenderFns } from "./login-afiliado.vue?vue&type=template&id=24aa991a"
import script from "./login-afiliado.vue?vue&type=script&lang=js"
export * from "./login-afiliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports